var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#09797A",
    stroke: "none",
    d: "M5.25 9.847v4.342c0 .502.229.69.366.756.136.067.423.131.802-.184l.99-.825c.326-.273.879-.273 1.206 0l.989.824c.223.185.413.24.56.24a.534.534 0 0 0 .243-.056c.137-.067.366-.254.366-.756v-4.36a4.911 4.911 0 0 0 1.979-3.947C12.751 3.19 10.62 1 8.001 1S3.25 3.19 3.25 5.881c0 1.637.794 3.079 2 3.966zm5.021 4.342c0 .186-.048.276-.081.292-.033.017-.132-.002-.272-.12l-.99-.824c-.506-.421-1.331-.421-1.835 0l-.989.824c-.141.117-.241.136-.272.12-.033-.016-.081-.106-.081-.292v-4.036c.672.376 1.431.61 2.249.61.827 0 1.593-.238 2.271-.621v4.047zM8 1.514c2.343 0 4.25 1.96 4.25 4.367a4.389 4.389 0 0 1-1.962 3.669h-.017v.01A4.134 4.134 0 0 1 8 10.25c-2.343 0-4.25-1.96-4.25-4.368 0-2.407 1.907-4.367 4.25-4.367Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.622eb649d82a8311248532b127e25370.svg";
export { ForwardRef as ReactComponent };